import { Paragraph2 } from "@bounce/design-system"

import { StoreCardSection } from "./StoreCardSection"

import HeartIcon from "@bounce/assets/icons/Heart.svg"

type StoreCardReviewReasonsSectionProps = {
  reviewSummaryText: string
}

export const StoreCardReviewReasonsSection = ({ reviewSummaryText }: StoreCardReviewReasonsSectionProps) => (
  <StoreCardSection icon={HeartIcon}>
    <Paragraph2 className="!text-[0.875rem]">{reviewSummaryText}</Paragraph2>
  </StoreCardSection>
)
